<script setup lang="ts">
import type { Participant } from '../types';

defineProps<{
  participants: Participant[];
  currentStreamer: Participant | null;
  isReceiving: boolean;
  isStreaming: boolean;
}>();

const emit = defineEmits<{
  (e: 'watch-stream'): void;
}>();
</script>

<template>
  <div class="flex flex-col h-full bg-[#1e1f22] rounded-lg border border-white/5 p-3 select-none">
    <div class="flex items-center justify-between pb-2 border-b border-white/5">
      <div class="flex items-center gap-1.5">
        <svg class="w-3.5 h-3.5 text-[#949ba4]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
        </svg>
        <span class="text-[11px] font-bold uppercase tracking-wider text-[#949ba4]">
          Na Chamada ({{ participants.length }})
        </span>
      </div>
    </div>

    <!-- Lista de Participantes -->
    <div class="flex-1 overflow-y-auto space-y-1 mt-2 pr-0.5">
      <div
        v-for="p in participants"
        :key="p.id"
        class="flex items-center justify-between p-1.5 rounded-md transition duration-150"
        :class="p.isStreaming ? 'bg-[#5865F2]/10 border border-[#5865F2]/30' : 'hover:bg-[#2b2d31] border border-transparent'"
      >
        <div class="flex items-center gap-2 min-w-0">
          <div class="relative flex-shrink-0">
            <img
              :src="p.avatarUrl"
              alt="Avatar"
              class="w-7 h-7 rounded-full bg-[#2b2d31] object-cover"
            />
            <span
              v-if="p.isStreaming"
              class="absolute -top-0.5 -right-0.5 flex h-2.5 w-2.5"
            >
              <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#f23f43] opacity-75"></span>
              <span class="relative inline-flex rounded-full h-2.5 w-2.5 bg-[#f23f43]"></span>
            </span>
          </div>

          <div class="truncate">
            <p class="text-xs font-medium text-[#dbdee1] truncate flex items-center gap-1">
              <span>{{ p.name }}</span>
              <span v-if="p.isSelf" class="text-[9px] text-[#949ba4] bg-white/5 px-1 rounded">você</span>
            </p>
            <p v-if="p.isStreaming" class="text-[10px] font-semibold text-[#f23f43]">
              Transmitindo
            </p>
          </div>
        </div>

        <!-- Botão Assistir se o participante estiver em live -->
        <button
          v-if="p.isStreaming && !p.isSelf && !isReceiving"
          @click="emit('watch-stream')"
          class="text-[11px] px-2 py-0.5 rounded bg-[#5865F2] hover:bg-[#4752C4] text-white font-medium shadow-xs transition cursor-pointer flex-shrink-0"
        >
          Assistir
        </button>
      </div>

      <div v-if="participants.length === 0" class="text-center py-6 text-[#949ba4] text-[11px]">
        Aguardando amigos entrarem...
      </div>
    </div>
  </div>
</template>
